import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import classNames from 'classnames';
import useIsMobile from 'Hooks/Common/useIsMobile';
import { AuthorizedRoutePaths } from 'Interfaces/RoutePaths';

const TrialBanner = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleRedirect = useCallback(() => {
    navigate(AuthorizedRoutePaths.TRY_TRIAL);
  }, [navigate]);

  return (
    <div className={classNames('header__banner', { mobile: isMobile })}>
      <div className="banner__container">
        <div className="banner__title">
          <span className="title__light">You have a 7-day Free Business Trial</span>
        </div>
        <div className="banner__button" onClick={handleRedirect}>
          Try now
        </div>
      </div>
    </div>
  );
};

export default TrialBanner;
